import {Component, OnDestroy, OnInit} from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-form-success',
  templateUrl: './form-success.component.html',
  styleUrls: ['./form-success.component.scss']
})
export class FormSuccessComponent implements OnInit, OnDestroy {

  constructor(private location: Location) { }

  ngOnInit(): void {
    window.addEventListener('popstate', () => {
      history.pushState(null, document.title, location.href);
      this.location.forward();

      // Add your custom logic or show a message to the user
      console.log('Back navigation is disabled in this component.');
    });
  }

  ngOnDestroy() {
    window.removeEventListener('popstate', () => { });
  }
}
